import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { signOut } from '../../store/actions/authActions';

const SignedInLinks = (props) => {
  return (
    <>
      <ul>
        <li className='list-none'><NavLink to='/createFJS'>New Post</NavLink></li>
        <li className='list-none'><a className='cursor-pointer' onClick={props.signOut}>Log Out</a></li>
        <li className='list-none'><NavLink to='/'>{props.profile.firstInitial}</NavLink></li>
      </ul>
    </>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut())
  }
}

export default connect(null, mapDispatchToProps)(SignedInLinks)